import { getFullName } from '../../gql/customerGql';
import { Deal, DealSourceEnum, DealSourceLabelMap } from '../../gql/dealGql';
import { Deal as GeneratedDeal } from '../../gql/generated/graphql';

import TextNotificationBadgeV2 from '../../components/NotificationBadge/TextNotificationBadgeV2';
import { TableColumns } from '../../components/shared/Table/types';

import { getBootedDealState } from './utils';

import { getUnseenMessageNotificationsCount } from '../../constants/notifications';
import { formatDate } from '../../libs/utils';

export type CalculatedProps = {
  unseenNotificationsCount?: ReturnType<typeof getUnseenMessageNotificationsCount>;
  lastDealState?: ReturnType<typeof getBootedDealState>;
};

export type DealWithCalculatedProps = (Deal | GeneratedDeal) & CalculatedProps;

export const betterBootedDealColumns: TableColumns<DealWithCalculatedProps> = [
  {
    header: '', // Notification column.
    getComponent: ({ item }) => <TextNotificationBadgeV2 count={item.unseenNotificationsCount} />,
    styleProps: {
      minW: '20px',
      maxW: '50px',
    },
  },
  {
    header: 'Date',
    getComponent: ({ item }) =>
      item.deal_dates?.dates?.booted ? formatDate(item.deal_dates?.dates?.booted) : '',
  },
  { header: 'Name', getComponent: ({ item }) => item.customer && getFullName(item.customer) },
  { header: 'Year', getComponent: ({ item }) => item.car?.year },
  { header: 'Make', getComponent: ({ item }) => item.car?.make },
  { header: 'Model', getComponent: ({ item }) => item.car?.model },
  { header: 'Reason', getComponent: ({ item }) => item.boot_reason?.reason },
  { header: 'Last State', getComponent: ({ item }) => item.lastDealState ?? '' },
  {
    header: 'Source',
    getComponent: ({ item }) => DealSourceLabelMap[item.source as DealSourceEnum] ?? '',
  },
  { header: 'Comment', getComponent: ({ item }) => item.boot_reason?.comment },
] as const;
